import React, { useEffect, useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import Icon3 from "../../assest/images/Icon3.png";
import Icon9 from "../../assest/images/Icon9.png";
import { ToastContainer, toast } from "react-toastify";
import config from "../../envconfig";
import { UserContext } from "../common/UserContext";
import { Modal, Button } from 'react-bootstrap';
import CustomDropdown from "../common/CustomDropdown";
import StatusCustomDropdown from "../common/StatusCustomDropdown";
function CITPMLIST() {
  const [userData, setUserdata] = useState([]);
  const [message, setMessage] = useState("");
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
    UM_UserType,
  } = useContext(UserContext);


  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [statusFilter, setStatusFilter] = useState("");
  const [remark, setRemark] = useState("");
  const [error, setError] = useState("");
  // New state for modal
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [isSelectOpen, setIsSelectOpen] = useState(false);

  const [searchOpt1, setSearchOpt1] = useState('');
  const [searchTxt1, setSearchTxt1] = useState('');
  const [searchOpt2, setSearchOpt2] = useState('');
  const [selectStatus, setSelectStatus] = useState('');
  const [searchTxt2, setSearchTxt2] = useState('');

  const getUserdata = async () => {
    try {
      const reqData = await fetch(`${config.API_URL}/CITPM/CITPM_LIST`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({

          UM_CompanyID, UM_UserType, UM_UserId, selectedScpId
        }),
      });


      if (reqData.ok) {
        const resData = await reqData.json();
        setUserdata(resData.data);
      } else {
        console.error("Error fetching the company list");
        setMessage("Error fetching the company list");
      }
    } catch (error) {
      console.log("Failed to fetch data:", error);
      setMessage("Please check data");
    }
  };

  useEffect(() => {
    getUserdata();
  }, []);

  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);
    sessionStorage.setItem("selectedScpId", selectedScpId);
    sessionStorage.setItem("UM_UserType", UM_UserType);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
    UM_UserType,
  ]);



  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Company IT Policy Master",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });

      if (!response.ok) {
        logAction("Failed to log action");
        throw new Error("Failed to log action");
      }
    } catch (error) {
      logAction("Error logging action:", true);
      console.error("Error logging action:", error);
    }
  };

  const filterData = userData.filter(item => {
    const v1 = searchOpt1 && searchTxt1 ? String(item[searchOpt1] ?? '').toLowerCase().includes(searchTxt1.toLowerCase()) : true;
    const v2 = searchOpt2 && searchTxt2 ? String(item[searchOpt2] ?? '').toLowerCase().includes(searchTxt2.toLowerCase()) : true;
    const statusMatch = !selectStatus || item.CITPM_Status === Number(selectStatus);

    const result = v1 && v2 && statusMatch;

    // console.log("🧾 FILTER CHECK:", {
    //   item,
    //   searchOpt1,
    //   searchTxt1,
    //   field1Value: item[searchOpt1],
    //   v1,
    //   searchOpt2,
    //   searchTxt2,
    //   field2Value: item[searchOpt2],
    //   v2,
    //   statusMatch,
    //   result
    // });

    return result;
  });


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filterData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );


  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Function to handle opening the modal
  const handleViewPolicy = (policy) => {
    setSelectedPolicy(policy);
    setShowPolicyModal(true);
    logAction(`handleViewPolicy() : Viewed policy details opened for Policy : ${policy.CITPM_PolicyName}`);
  };

  // Function to close the modal
  const handleCloseModal = () => {

    setShowPolicyModal(false);
    setTimeout(() => {
      setSelectedPolicy(null);
    }, 500);

  };

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };

  // Base options (without PolicyType)
  const baseOptions = (searchOpt) => [

    { value: 'CITPM_PolicyName', label: 'Policy Name', isDisabled: searchOpt === 'CITPM_PolicyName' },

  ];

  // Options visible only if UM_UserType === 0
  const conditionalOptions = (searchOpt) => [
    // { value: 'CGM_CompanyGroupName', label: 'Company Group Name', isDisabled: searchOpt === 'CGM_CompanyGroupName' },
    { value: 'CM_CompanyName', label: 'Company Name', isDisabled: searchOpt === 'CM_CompanyName' },
  ];

  const policyOption = (searchOpt) => ([
    {
      value: 'PolicyType',
      label: 'Policy Type',
      isDisabled: searchOpt === 'PolicyType',
    },
    {
      value: 'SCPM_Name',
      label: 'SCP Name',
      isDisabled: searchOpt === 'SCPM_Name',
    }
  ]);

  const buildOptions = (searchOpt, otherOpt) => {
    //console.log("🔷 buildOptions CALLED", { searchOpt, otherOpt, UM_UserType });

    let opts = [];

    if (parseInt(UM_UserType) === 0) {
      opts = [
        ...conditionalOptions(searchOpt),
        ...baseOptions(searchOpt),
        ...policyOption(searchOpt),
      ];
    } else if (parseInt(UM_UserType) === 1) {
      opts = [
        ...baseOptions(searchOpt),
        ...policyOption(searchOpt),
      ];
    } else {
      opts = [...baseOptions(searchOpt)];
    }

    //console.log("🟡 Before Disable Mapping:", opts);

    const processed = opts.map(o => ({
      ...o,
      isDisabled: o.value === searchOpt || o.value === otherOpt,
      disabled: o.value === searchOpt || o.value === otherOpt
    }));

    //console.log("🟢 After Disable Mapping:", processed);

    return processed;
  };

  // Usage
  const options = buildOptions(searchOpt1);
  const options2 = buildOptions(searchOpt2);


  const statusOptions = [
    { value: '', label: '--Select Status--' },
    { value: 1, label: 'Active' },
    { value: 2, label: 'Inactive' },
  ];


  const handleOpt1 = (selectedOption) => {
    const newValue = selectedOption?.target?.value || '';
    setSearchTxt1('');
    //console.log("🔵 handleOpt1 NEW VALUE:", newValue);
    setSearchOpt1(newValue);
  };

  const handleOpt2 = (selectedOption) => {
    const newValue = selectedOption?.target?.value || '';
    setSearchTxt2('');
    //console.log("🟣 handleOpt2 NEW VALUE:", newValue);
    setSearchOpt2(newValue);
  };

  const handleTxt1 = (e) => {
    setSearchTxt1(e.target.value);
  };

  const handleTxt2 = (e) => {
    setSearchTxt2(e.target.value);
  };
  const handleStatus = (selectedOption) => {
    const newValue = selectedOption?.target?.value || '';
    //console.log("🟢 handleStatus NEW VALUE:", newValue);
    setSelectStatus(newValue);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchOpt1, searchTxt1, searchOpt2, searchTxt2, selectStatus]);

  return (
    <React.Fragment>
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      <div className="main_container">
        <div className="row">
          <div className="col-md-12">
            <h5 className="formHeading">Company IT Policy Master</h5>
            <p>{message}</p>
            <div className="filter-container">
              <div className='select-container_list'>
                <CustomDropdown
                  name="searchOpt1"
                  options={options2}
                  value={searchOpt1}                           // value from state
                  onChange={(selectedOption) => handleOpt1(selectedOption)}
                  placeholder="--Select--"
                  idKey="value"                                // change if key is different
                  displayKey="label"                           // change if key is different
                  disabled={false}
                  onMenuOpen={() => handleSelectOpen("searchOpt1")}
                  onMenuClose={handleSelectClose}
                />
              </div>
              <input type='text' value={searchTxt1} onChange={handleTxt1} className='search-input searchbar' placeholder="Search"></input>

              <div className='select-container_list'>
                <CustomDropdown
                  name="searchOpt2"
                  options={options}
                  value={searchOpt2}                          // selected value
                  onChange={(selectedOption) => handleOpt2(selectedOption)}
                  placeholder="--Select--"
                  idKey="value"                               // adjust if your object key differs
                  displayKey="label"                          // adjust if your key differs
                  disabled={false}
                  onMenuOpen={() => handleSelectOpen("searchOpt2")}
                  onMenuClose={handleSelectClose}
                />




              </div>
              <input type='text' value={searchTxt2} onChange={handleTxt2} className='search-input searchbar' placeholder="Search"></input>
              <div className='select-container_list'>
                <StatusCustomDropdown
                  name="statusFilter"
                  options={statusOptions}
                  value={selectStatus}                        // selected value (not the whole object)
                  onChange={(e) => handleStatus(e)}           // e.target.value will be passed
                  idKey="value"                               // adjust if key differs
                  displayKey="label"                          // adjust if key differs
                  onMenuOpen={() => handleSelectOpen('statusFilter')}
                  onMenuClose={handleSelectClose}
                />



              </div>
            </div>

            <div className="ptable-wrapper">
              <table className="ptableClass">
                <thead>
                  <tr>
                    <th style={{ width: "70px" }}>Sr. No.</th>
                    {(parseInt(UM_UserType) === 0) && (
                      <>
                        {/* <th>Company Group Name</th> */}
                        <th>Company Name</th>
                      </>
                    )}
                    <th>Policy Name</th>
                    {(parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) && (

                      <>
                        <th>Policy Type</th>
                        <th>SCP Name</th>
                      </>
                    )}




                    <th>Password Policy</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {currentItems.length === 0 ? (
                  <tbody>
                    <tr>
                      <td colSpan="12">No Records Found</td>
                    </tr>
                  </tbody>
                ) : (
                  <>
                    <tbody>
                      {currentItems.map((user, index) => (
                        <tr key={index}>
                          <td style={{ width: "70px" }}>
                            {index + 1 + (currentPage - 1) * itemsPerPage}
                          </td>
                          {parseInt(UM_UserType) === 0 && (
                            <>

                              <td>{user.CM_CompanyName}</td>
                            </>
                          )}
                          <td>{user.CITPM_PolicyName}</td>
                          {(parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) && (
                            <>
                              <td>{user.PolicyType}</td>
                              <td>{user.SCPM_Name || "-"}</td>
                            </>
                          )}
                          <td>
                            <img
                              src={Icon9}
                              alt="Details"
                              className="show-button"
                              title="Details"
                              onClick={() => handleViewPolicy(user)}
                              style={{ cursor: "pointer" }}
                            />
                          </td>
                          <td>
                            {user.CITPM_Status === 1 && "Active"}
                            {user.CITPM_Status === 2 && "Inactive"}
                          </td>
                          <td style={{ paddingLeft: '15px' }}>
                            {/* {parseInt(user.CITPM_CreatedBy) === 0 && parseInt(UM_UserType) !== 0 ? (
                              "-"
                            ) : ( */}
                            <Link to={`/citpm_edit/${user.CITPM_PolicyID}`}>
                              <img src={Icon3} alt="Edit" className="editicon" title="Edit" />
                            </Link>
                            {/* )} */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </>
                )}
              </table>
            </div>
          </div>
        </div>
       
        <ul className="pagination">
          <li
            className={
              currentPage === 1 || filterData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button className="page-linkd" onClick={() => paginate(1)}>
              First
            </button>
          </li>
          <li
            className={
              currentPage === 1 || filterData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() => paginate(currentPage - 1)}
            >
              Previous
            </button>
          </li>
          {Array.from(
            { length: Math.ceil(filterData.length / itemsPerPage) },
            (_, index) => (
              <li
                key={index}
                className={
                  currentPage === index + 1 ? "page-item active" : "page-item"
                }
              >
                <button
                  className="page-linkd"
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            )
          )}
          <li
            className={
              currentPage ===
                Math.ceil(filterData.length / itemsPerPage) ||
                filterData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() => paginate(currentPage + 1)}
            >
              Next
            </button>
          </li>
          <li
            className={
              currentPage ===
                Math.ceil(filterData.length / itemsPerPage) ||
                filterData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() =>
                paginate(Math.ceil(filterData.length / itemsPerPage))
              }
            >
              Last
            </button>
          </li>
        </ul>

        <br />
        <br />
      </div>

      <Modal
        show={showPolicyModal && !!selectedPolicy}
        onHide={handleCloseModal}
        size="lg"
        backdrop="static"
        centered
        keyboard={false}
        animation={false}
        style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Password Policy Details
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ textAlign: 'left' }}>
          <h6 className="word-wrap">
            Policy : {selectedPolicy?.CITPM_PolicyName || 'N/A'}
          </h6>

          <table className="tableClass">
            <tbody>
              <tr>
                <th style={{ backgroundColor: 'transparent' }}>Session Time Out (Minutes)</th>
                <td>{selectedPolicy?.CITPM_SessionTimeOut || 'N/A'}</td>
              </tr>
              <tr>
                <th style={{ backgroundColor: 'transparent' }}>Password Attempts</th>
                <td>{selectedPolicy?.CITPM_FailAttempt || 'N/A'}</td>
              </tr>
              <tr>
                <th style={{ backgroundColor: 'transparent' }}>Password Never Expire</th>
                <td>{selectedPolicy?.CITPM_PwdNeverExpiry || 'N/A'}</td>
              </tr>
              <tr>
                <th style={{ backgroundColor: 'transparent' }}>Password Change Duration (Days)</th>
                <td>{selectedPolicy?.CITPM_PwdChangeDuration || 'N/A'}</td>
              </tr>
              <tr>
                <th style={{ backgroundColor: 'transparent' }}>Password Expire Notification (Days)</th>
                <td>{selectedPolicy?.CITPM_PwdNotificationDuration || 'N/A'}</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>


      </Modal>

      <Link to={`/dashboard/citpm`} className="back_btn" type="button">
        BACK
      </Link>
    </React.Fragment>
  );
}




export default CITPMLIST;
